import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import Parser from 'html-react-parser';
import AuLogo from '../../../../assets/Images/autommate-transparent.png';
import Details from './Details';
import {Tooltip} from "@material-ui/core";

/**
 * @Description This function lets you return Bot card component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Card({bot, type}) {
    const label = 'CONTENT.BOT.';
    const [open, setOpen] = useState(false);
    const {t} = useTranslation();
    const handleClick = () => {
        setOpen(true);
    };
    const appImages = bot.application_image?.split('##');
    const appNames = bot.application_name?.split(',');
    const totalAppSize = appImages?.length;

    let bpn = bot.business_process_name?.split(',');
    let cn = bot.categories_name?.split(',');

    return (
        <div className="bot-card">
            <div className="bot-header">
                <div onClick={handleClick} className="content-overflow"
                     title={bot.bot_name}>
                    {bot.bot_name}
                </div>
                <div>PAID</div>
            </div>
            <div className="bot-desc">{Parser(bot.short_description ? bot.short_description : '')}</div>
            <div className="bot-developer">
                <div>
                    <div className="bot-label">{t(label + 'COMPATIBLE-WITH')}</div>
                    <div className="bot-img" style={{marginTop: 20, display: "flex", alignItems: "center"}}>
                        {appImages?.map((item, itemI) => {
                            if (itemI <= 1)
                                return <div className="compatible-logo">
                                    <img src={item} style={{width: "100%", maxHeight: 40}} alt={appNames[itemI]}/>
                                </div>
                        })
                        }
                        {appImages?.length > 2 && (
                            <div>
                                <span className="plus-application-size">+{totalAppSize - 2}</span>
                            </div>
                        )}

                    </div>

                </div>
                <div>
                    <div className="bot-label">{t(label + 'DEVELOPER')}</div>
                    <div className="bot-img">
                        <img src={AuLogo} alt="autommate" width={150} style={{marginTop: 15}}/>
                    </div>
                </div>
            </div>
            <div className="bot-footer">
                <div className="bot-badge blue">{bot.automation_type_name}</div>
                <div className="badge-container">
                    {bpn?.map((item, itemI) => {
                        if (itemI < 1) {
                            return <div className="bot-badge red">{item}</div>
                        }
                    })}
                    {bpn?.length > 1 ? <Tooltip title={bpn?.slice(1, bpn?.length).join(', ')}><span
                        className="badge-plus-size red">+{bpn?.length - 1}</span></Tooltip> : null}
                </div>
                <div className="badge-container">
                    {cn?.map((item, itemI) => {
                        if (itemI < 1) {
                            return <div className="bot-badge orange">{item}</div>
                        }
                    })}
                    {cn?.length > 1 ? <Tooltip title={cn?.slice(1, cn?.length).join(', ')}><span
                        className="badge-plus-size orange">+{cn?.length - 1}</span></Tooltip> : null}
                </div>
                <div className="badge-container">
                    {appNames?.map((item, itemI) => {
                        if (itemI < 1) {
                            return <div className="bot-badge gray">{item}</div>
                        }
                    })}
                    {appNames?.length > 1 ? <Tooltip title={appNames?.slice(1, appNames?.length).join(', ')}><span
                        className="badge-plus-size gray">+{appNames?.length - 1}</span></Tooltip> : null}
                </div>
            </div>
            {open && <Details setOpen={setOpen} bot={bot}/>}
        </div>
    );
}

export default Card;
